export type TermsType =
  | 'privacy'
  | 'cookie'
  | 'term'
  | 'privacy_collect'
  | 'privacy_collect_payment'
  | 'term_marketing';

type LanguageStrings = {
  en?: string;
  ko?: string;
};

type TermsFeature = {
  label: LanguageStrings;
  modalTitle?: LanguageStrings;
  setting_key: string;
};

export const termsFeature: Record<TermsType, TermsFeature> = {
  cookie: {
    label: { en: 'Cookie Policy', ko: '쿠키정책' },
    setting_key: 'term_cookie_',
  },
  privacy: {
    label: { en: 'Privacy Policy', ko: '개인정보처리방침' },
    setting_key: 'term_privacy_',
  },
  privacy_collect: {
    label: {
      en: 'Consent to Collection and Use of Personal Information',
      ko: '개인정보 수집 이용 동의',
    },
    setting_key: 'term_privacy_collect_',
  },
  privacy_collect_payment: {
    label: {
      en: 'Consent to Collection and Use of Personal Information',
      ko: '개인정보 수집 및 이용동의',
    },
    modalTitle: {
      en: 'Consent to Collection and Use of Personal Information',
      ko: '개인정보 수집 및 이용동의',
    },
    setting_key: 'term_privacy_collect_payment_',
  },
  term: {
    label: { en: 'Terms & Condition', ko: '이용약관' },
    setting_key: 'term_tos_',
  },
  term_marketing: {
    label: { en: 'Marketing Agreement', ko: '마케팅수신동의' },
    modalTitle: { en: 'Marketing Agreement', ko: '마케팅수신동의' },
    setting_key: 'term_marketing_',
  },
};
